import React, { useEffect, useRef } from "react";
import { useTranslation } from "react-i18next";

const AftershipIframe = (props) => {
  const { i18n } = useTranslation();
  const language = i18n.resolvedLanguage;
  const trackingNumber = props.trackingNumber;
  const orderId = props.orderId;
  const email = props.email;
  const aftershipIframeRef = useRef(null);
  const orderIdAndEmailUrl = `https://username.aftership.com/order-status?order-number=${orderId}&email=${email}&lang=${language}&username=${process.env.REACT_APP_AFTERSHIP_USER}&iframe=1&page-name=iframe`;
  const trackingNumberUrl = `https://username.aftership.com/${trackingNumber}?iframe=1&lang=${language}&username=${process.env.REACT_APP_AFTERSHIP_USER}&page-name=iframe`;
  const iframeSrc = orderId && email ? orderIdAndEmailUrl : trackingNumberUrl;

  useEffect(() => {
    const resizeEventHandler = (event) => {
      if (
        event.data &&
        event.data.type === "resize" &&
        typeof event.data.scrollHeight === "number" &&
        aftershipIframeRef.current
      ) {
        aftershipIframeRef.current.style.height =
          event.data.scrollHeight + "px";
      }
    };

    const widgetScriptLoadEventHandler = (event) => {
      if (
        event.data &&
        event.data.type === "widgetScriptLoad" &&
        typeof event.data.scripts === "object"
      ) {
        event.data.scripts.forEach((script) => {
          const scriptDom = document.createElement("script");
          scriptDom.innerHTML = script;
          document.body.appendChild(scriptDom);
          window.postMessage({ type: "hideAllWidget" }, "*");
        });
      }
    };

    window.addEventListener("message", resizeEventHandler);

    window.addEventListener("message", widgetScriptLoadEventHandler);

    return () => {
      window.removeEventListener("message", resizeEventHandler);

      window.removeEventListener("message", widgetScriptLoadEventHandler);
    };
  }, []);

  return (
    <iframe
      ref={aftershipIframeRef}
      style={{ width: "100%", display: "none" }}
      id="as-tracking-page"
      scrolling="no"
      frameBorder="0"
      src={iframeSrc}
      onLoad={(ev) => (ev.target.style.display = "block")}
    ></iframe>
  );
};

export default AftershipIframe;
